import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useState } from "react";
import styles from "./Login.module.css";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../redux/actions/user/forgotPasswordAction";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

const { Title } = Typography;

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const onFinish = async (values) => {
    setLoader(true);
    const resp = await dispatch(forgotPassword(values.email));
    if (resp === "success") {
      setLoader(false);
      // Navigate to login with code page
      navigate("/auth/login-with-code", { state: { email: values.email } });
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoader(false);
    toast.error("Please enter a valid email address");
  };

  return (
    <>
      <Row className="card-row" justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
          <Card bordered={false} className={styles.card} style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
            <Title level={2} className="text-center" style={{ marginBottom: "1rem", marginTop: "0" }}>
              Forgot Password
            </Title>
            
            <p style={{ textAlign: "center", color: "#666", marginBottom: "1.5rem" }}>
              Enter your email address and we'll send you a 6-digit code to reset your password.
            </p>

            <Form
              name="forgotPassword"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                className="mb-2"
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter your email address" />
              </Form.Item>

              <Form.Item className="mt-2">
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={loader}
                  onClick={() => setLoader(true)}
                  block
                >
                  Send Reset Code
                </Button>
              </Form.Item>

              <Form.Item className="text-center mt-2">
                <Link to="/auth/login">Back to Login</Link>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ForgotPassword;
